module.exports = __webpack_public_path__ + "img/SI5860571.8cb96b71.png";